import {
  IHeadingPageElement,
  IBodyTextPageElement,
  IPageDividerElementConfig,
  IPageDividerPageElement,
  ITasksElementConfig,
  ITasksPageElement,
  IOfferSelectionElementConfig,
  IOfferSelectionPageElement,
  IImageElementConfig,
  IImagePageElement,
  IButtonsElementConfig,
  IButtonsPageElement,
  ITextElementConfig,
  IDataInputPageElement,
  IDataInputElementConfig,
  IProgressBarPageElement,
  IProgressBarElementConfig,
  IDocuSignESignatureElement,
  IDocuSignESignatureElementConfig,
  ITextColumnsElement,
  ITextColumnsElementConfig,
  ISelectionOptionsElement,
  ISelectionOptionsElementConfig,
  PortalPageElementType,
  IPlaidLinkPageElement,
  IPlaidLinkElementConfig,
  ICustomHtmlElementConfig,
  ICustomHtmlPageElement,
  IQuilttConnectElementConfig,
  IQuilttConnectPageElement,
} from './portal-page-elements';
import BasePortalPageElementsRestApi, {
  IPortalPageElementsApi,
} from './portal-page-elements/BasePortalPageElementsApi';

export type ITextPageElement =
  | IHeadingPageElement
  | IBodyTextPageElement;

export type IPortalPageElement =
  | ITextPageElement
  | IPageDividerPageElement
  | ITasksPageElement
  | IOfferSelectionPageElement
  | IImagePageElement
  | IButtonsPageElement
  | IDataInputPageElement
  | IProgressBarPageElement
  | ICustomHtmlPageElement
  | IDocuSignESignatureElement
  | ITextColumnsElement
  | ISelectionOptionsElement
  | IPlaidLinkPageElement
  | IQuilttConnectPageElement;

export type IPageElementConfig =
  | ITextElementConfig
  | IPageDividerElementConfig
  | ITasksElementConfig
  | IOfferSelectionElementConfig
  | IImageElementConfig
  | IButtonsElementConfig
  | IDataInputElementConfig
  | IProgressBarElementConfig
  | ICustomHtmlElementConfig
  | IDocuSignESignatureElementConfig
  | ITextColumnsElementConfig
  | ISelectionOptionsElementConfig
  | IPlaidLinkElementConfig
  | IQuilttConnectElementConfig;

export interface IFindPortalPageElementsParams {
  statusId: string;
}

export default class PortalPageElementsRestApi
  extends BasePortalPageElementsRestApi<PortalPageElementType, IPortalPageElement, IFindPortalPageElementsParams>
  implements IPortalPageElementsApi<
    IPortalPageElement,
    IFindPortalPageElementsParams
  > {
  protected resourceName = 'portal-page-elements';
}
